/*Add Custom JS Here*/
$(document).ready(function() {
  var i = 1;
    $('.shopify-section').each(function(){
      $(this).addClass('section_no_'+i);
      i++;
	});
});

$(document).ready(function() {
  var j = 1;
    $('#MobileNav li').each(function(){
      $(this).addClass('menu-item-'+j);
      j++;
	});
});

/* Sort By Brand */

$('.select-brand ul li').click(function() {
    var select_brand = $(this).siblings().toggle();
    $(this).parent().prepend(this);
});

/* -- code for image gallery pop-up -- */
$(document).ready(function() {
  $('#shopify-section-press img').each(function() {
      var currentImage = $(this);
      currentImage.wrap("<a class='image-link' title='" + currentImage.attr("title") + "' href='" + currentImage.attr("src") + "'</a>");
  });

  $('.image-link').magnificPopup({
      type: 'image',
      titleSrc: function(item) {
        return item.el.attr('title');
      },    
      gallery: {
        enabled: true, 
        preload: [0,2],
        navigateByImgClick: true,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
        tPrev: 'Previous (Left arrow key)', 
        tNext: 'Next (Right arrow key)', 
        tCounter: '<span class="mfp-counter">%curr% of %total%</span>'
      },    
      mainClass: 'mfp-with-zoom', 
      zoom: {
        enabled: true, 
        duration: 300, 
        easing: 'ease-in-out', 
        opener: function(openerElement) {
        return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  });  
});
/* - end - */

$(document). ready(function() { 
   $(".template-index .bun-colmn").owlCarousel({ 
     responsiveClass: true,
     lazyLoad : true, 
     loop : true,
     autoplay: false,
     autoplayTimeout: 4000,
     dots: false,
     navigation : true, 
     afterAction: function(elem1){ 
    	$(elem1). addClass("curent"); 
     },
    responsive: {
    0: {
      items: 1
    },

    650: {
      items: 2
    },

    1024: {
      items: 3
    },

    1366: {
      items: 3
    }
  }
}); 
});

/*jQuery.noConflict();
jQuery(document).ready(function() {
      jQuery("#shopify-section-16414113083d641ea1 .grid-uniform").owlCarousel({

      navigation : true,
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem : false

      // "singleItem:true" is a shortcut for:
      // items : 1,
      // itemsDesktop : false,
      // itemsDesktopSmall : false,
      // itemsTablet: false,
      // itemsMobile : false

      });
    });*/

$(document). ready(function() { 
  /*$("#shopify-section-16414113083d641ea1 .grid-uniform").owlCarousel({ */
   $(".product-slider .grid-uniform").owlCarousel({ 
     responsiveClass: true,
     lazyLoad : true, 
     loop : true,
     autoplay: false,
     autoplayTimeout: 4000,
     dots: false,
     navigation : true, 
     afterAction: function(elem){ 
    	$(elem). addClass("curent"); 
     },
    responsive: {
    0: {
      items: 1
    },

    768: {
      items: 2
    },

    1024: {
      items: 3
    },

    1366: {
      items: 4
    }
  }
}); 
});

/* Single Product Toggle */
var acc = document.getElementsByClassName("expand-me");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var details = this.nextElementSibling;
    if (details.style.display === "block") {
      details.style.display = "none";
    } else {
      details.style.display = "block";
    }
  });
}


$(document).ready(function() {
    // Configure/customize these variables.
    var moretext = "Show More";
    var lesstext = "Show Less";
    
 $(".moreless").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        
    });
});

jQuery(function($){
    $('.moreless').click(function(){
      $('.details').toggleClass('expand-discription');   
    });  
});

/* Header Search Toggle Start */
jQuery(function($){
    $('.display-search-bar').click(function(){
      $('.menu-header-search-bar').toggleClass('show-search-bar');  
      $('.display-search-bar').toggleClass('close-search-bar'); 
    });  
});

/* Header Search Toggal End */

jQuery(function($){
    $('.product-description h4.expand-me').click(function(){
      $('.moreless').toggleClass('hide');   
    });  
});

$(document).ready(function() {
 $(".CTI.CTI_p1").parent().css('max-width','100%');
  $( ".hr" ).parent().parent().css('max-width','100%');
	/* $('.shopify-section').hasClass('.CTI.CTI_p1').css('max-width','100%');       */
});


jQuery(function($){
 setTimeout(function(){
	var $val = $('#AddToCartText').text();
	if($val == 'Sold Out'){
 		$('.shipping-time').addClass('show-shipping-time');
	}}, 2000);
});

jQuery(function($) {
  setTimeout(function(){
  	 $('.lb-upsell-money').attr('id', 'main-product-price');
	}, 5000);
});

/* Calculator Modal Start */
$("#howtocalc").click(function(){
  $(".calc-modal").addClass("open-calc");
  $("html").addClass("overflow");
});

$("#calc-close").click(function () {
    $("#calc-modal").removeClass("open-calc");
  	$("html").removeClass("overflow");
});

$(document).ready(function(){
    $("#calc-close-btn").click(function(){
      $("#calc-modal").removeClass("open-calc");
      $("html").removeClass("overflow");
    });
 });


$(document).ready(function(){
    $('#height-ft').keyup(calculate);
    $('width-ft').keyup(calculate);
});

$(document).ready(function() {
    $("#persqft .money").html(function () {
		return $(this).html().replace('$', '').replace('USD', '');
	});	
   $("#persqft .money").html(function () {
		return $(this).html().replace('Rs.', '');
	});	
});

function calculate() {
  document.getElementById("add-extra-for-waste-and-reserve").disabled = false;
  var tileHeight = document.getElementById('height-ft').value;	
  var tileWidth = document.getElementById('width-ft').value;
  var waste = document.getElementById('enter-waste').value;
  var totalsqft = document.getElementById('totalsqft');
  var pricepersqft = document.getElementById('ProductPrice').innerHTML.replace(/[^\d.-]/g, '');
  var totalwaste = document.getElementById('totalwaste');
  var finalprice = document.getElementById('totalprice');
  var totalArea =  document.getElementById('totalarea');
  var sqftArea =  document.getElementById('sqftarea');
  var myResult = tileHeight * tileWidth;
  var wasteResult = myResult * waste / 100;
  var trResult = myResult + wasteResult;
  totalsqft.innerHTML = myResult;
  totalwaste.innerHTML = wasteResult;
  totalArea.innerHTML = trResult;
  finalprice.innerHTML = (pricepersqft * myResult).toFixed(2);
  sqftArea.innerHTML = totalsqft.innerHTML;
}

document.addEventListener('DOMContentLoaded', function() {
  	var checkboxes = document.querySelectorAll('input[type=checkbox]');
	var pricepersqft = document.getElementById('ProductPrice').innerHTML.replace(/[^\d.-]/g, '');
  	var sqftArea =  document.getElementById('sqftarea');
  
  for (var checkbox of checkboxes) {
    checkbox.addEventListener('change', function(event) {
      if (event.target.checked) {
		document.getElementById('enter-waste').value = '10';
        document.getElementById('totalwaste').innerHTML = document.getElementById('totalsqft').innerHTML * document.getElementById('enter-waste').value / 100;
        document.getElementById('totalarea').innerHTML = parseInt(document.getElementById('totalsqft').innerHTML) + parseInt(document.getElementById('totalwaste').innerHTML);
        document.getElementById('totalprice').innerHTML = document.getElementById('totalarea').innerHTML * pricepersqft;
        sqftArea.innerHTML = document.getElementById('totalarea').innerHTML;
	} else {
        document.getElementById('enter-waste').value = '0';
      	document.getElementById('totalwaste').innerHTML = document.getElementById('totalsqft').innerHTML * document.getElementById('enter-waste').value / 100;
      	document.getElementById('totalarea').innerHTML = document.getElementById('totalsqft').innerHTML;
      	document.getElementById('totalprice').innerHTML = document.getElementById('totalarea').innerHTML * pricepersqft;
      	sqftArea.innerHTML = document.getElementById('totalarea').innerHTML;
      }
    });
  }
}, false);

$(function() {
    $('#persqft').each(function(){
        $('.money').attr('id', "cprice");
    });
});

//window.onload = function() {
setTimeout(function(){
 	/*document.getElementById('totalprice').innerHTML = document.getElementById('ProductPrice').innerHTML.replace(/[^\d.-]/g, '');
  	document.getElementById('persqft').innerHTML = document.getElementById('ProductPrice').innerHTML;*/
    document.getElementById('totalprice').innerHTML = document.getElementById('ProductPrice').innerHTML; 
  	document.getElementById('persqft').innerHTML = document.getElementById('ProductPrice').innerHTML;
    document.getElementById('sqftarea').innerHTML = document.getElementById("Quantity").value;
    document.getElementById("sqft").value = document.getElementById('sqftarea').innerHTML;
},10);

function updatePrice() {
    document.getElementById("Quantity").value = Math.round(document.getElementById('totalsqft').innerHTML);
  	document.getElementById("sqft").value = Math.round(document.getElementById('totalsqft').innerHTML);
  calculatesqft();
}

function calculatesqft() {
  	document.getElementById("Quantity").value = document.getElementById("sqft").value;
  	document.getElementById('sqftarea').innerHTML = document.getElementById("sqft").value;
   
    document.getElementById("height-ft").value = "";
  	document.getElementById("width-ft").value = "";
  
  	var sqftarea = document.getElementById('sqftarea').innerHTML;
    var persqft = document.getElementById('cprice').innerHTML.replace('Rs.', '').replace(/[^\d.-]/g, '');
  	var totalprice = document.getElementById('totalprice');
  
  	totalprice.innerHTML = (sqftarea * persqft).toFixed(2);  
  
}/*
function calculatesqft() {
  	document.getElementById('sqftarea').innerHTML = document.getElementById("sqft").value;
    
  	var sqftarea = document.getElementById('sqftarea').innerHTML;
    var persqft = document.getElementById('cprice').innerHTML.replace('Rs.', '').replace(/[^\d.-]/g, '');
  	var totalprice = document.getElementById('totalprice');
  
  	totalprice.innerHTML = (sqftarea * persqft).toFixed(2); 
  
}
*/
function restsqft() {
    document.getElementById("sqft").value = "1";
  	document.getElementById('sqftarea').innerHTML = "1";
  
    var sqftarea = document.getElementById('sqftarea').innerHTML;
  	//var persqft = document.getElementById('persqft').innerHTML;
    var persqft = document.getElementById('cprice').innerHTML.replace('Rs.', '').replace(/[^\d.-]/g, '');
  	var totalprice = document.getElementById('totalprice');
  
  	totalprice.innerHTML = (sqftarea * persqft).toFixed(2); 
}


$(document).ready(function() {
  $('.calc').scroll(function(){
      if ($(this).scrollTop() > 50) {
         $('.calc-header').addClass('sticky');
      } else {
         $('.calc-header').removeClass('sticky');
      }
  });
});

/* Calculator Modal End */

/* Sticky Single Product Page Image & Gallery Start*
$(document).ready(function() { */

  var $window = $(window);  
  var $sidebar = $(".left-side"); 
  var $sidebarHeight = $sidebar.innerHeight();   
  var $footerOffsetTop = $(".review-section").offset().top; 
  var $sidebarOffset = $sidebar.offset();
  
  $window.scroll(function() {
    if($window.scrollTop() > $sidebarOffset.top) {
      $sidebar.addClass("posFix");   
    } else {
      $sidebar.removeClass("posFix");   
    }    
    if($window.scrollTop() + $sidebarHeight > $footerOffsetTop) {
      $sidebar.css({"top" : -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});        
    } else {
      $sidebar.css({"top": "0",});  
    }    
  });   

/* });
Sticky Single Product Page Image & Gallery End*/


/* Corner Filter Js Start */

function cornerFilter() {
    var input, filter, a, i, txtValue;
    input = document.getElementById("searchInput");
    filter = input.value.toUpperCase();
    var cornerList = document.getElementById("searchCorner");
    var corneritem = cornerList.querySelectorAll(".grid__item");
    for (i = 0; i < corneritem.length; i++) {
        a = corneritem[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            corneritem[i].style.display = "";
        } else {
            corneritem[i].style.display = "none";
        }
    }
}
